import styled from 'styled-components';
import { IC_PENDING_RED } from '../../../../Assets/images';

export const ProfileImageUploadStyled = styled.div`
  position: relative;
  .title {
    font-size: 18px;
    font-weight: 700;
  }
  .profile-wrapper {
    position: relative;
  }
  .p-icon {
    position: absolute;
    top: -45px;
    z-index: 2;
  }
  .p-image {
    position: absolute;
    top: 60px;
    left: 75px;
  }
  .file-upload {
    width: 38px;
    position: absolute;
    top: 5px;
    left: 0;
    border-radius: 50%;
    opacity: 0;
  }
  .profile-pic {
    margin-top: 20px;
    img {
      border-radius: 50%;
    }
  }
  .invalid-feedback {
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.verification.red.main};
  }
  .avtar-name {
    overflow: hidden;
    background: ${(props) => props.theme.blue.grey};
    color: ${(props) => props.theme.color.white};
    font-size: 36px;
    text-align: center;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
